import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";
import { LEGAL } from "@/constants/legal";

export default function PrivacyPolicy() {
  return (
    <LegalLayout overline="Informativa sulla protezione dei dati" title="Privacy Policy">
      <p className="lead">
        Ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 (di seguito,
        "GDPR") e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018,
        forniamo l'informativa sul trattamento dei tuoi dati personali.
      </p>

      <h2>1. Titolare del Trattamento</h2>
      <p>
        <strong>{LEGAL.ownerName}</strong>
        <br />
        Indirizzo: {LEGAL.address}
        <br />
        Codice Fiscale: {LEGAL.fiscalCode}
        <br />
        Email: <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>
        <br />
        WhatsApp: {LEGAL.whatsapp}
      </p>
      <p>
        Per qualsiasi richiesta relativa al trattamento dei tuoi dati personali
        puoi contattarci ai recapiti sopra indicati.
      </p>

      <h2>2. Tipologie di dati raccolti</h2>
      <p>Tra i dati personali raccolti da questo sito, in modo autonomo o tramite terze parti, ci sono:</p>
      <ul>
        <li>
          <strong>Dati di navigazione</strong>: indirizzo IP, tipo di browser,
          sistema operativo, pagine visitate, orario della richiesta (raccolti
          solo previo consenso ai cookie statistici).
        </li>
        <li>
          <strong>Dati forniti volontariamente</strong>: nome, cognome,
          indirizzo email, numero di telefono, contenuto dei messaggi tramite i
          moduli di contatto e di iscrizione alla newsletter.
        </li>
        <li>
          <strong>Dati relativi all'acquisto</strong>: in caso di acquisto
          tramite Stripe, sono trattati da Stripe Inc. (vedi punto 7) i dati di
          pagamento (carta, indirizzo di fatturazione). Il Titolare non ha
          accesso ai dati completi della carta.
        </li>
      </ul>
      <p>
        Il conferimento dei dati è in alcuni casi obbligatorio per usufruire
        del servizio richiesto (es. ricevere il PDF, essere ricontattati). Il
        mancato conferimento può comportare l'impossibilità di erogare il
        servizio.
      </p>

      <h2>3. Finalità e basi giuridiche del trattamento</h2>
      <table>
        <thead>
          <tr>
            <th>Finalità</th>
            <th>Base giuridica (Art. 6 GDPR)</th>
            <th>Conservazione</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Risposta a richieste di contatto</td>
            <td>Esecuzione di misure precontrattuali (lett. b)</td>
            <td>24 mesi</td>
          </tr>
          <tr>
            <td>Iscrizione newsletter / invio estratto PDF</td>
            <td>Consenso esplicito (lett. a)</td>
            <td>Fino a revoca del consenso</td>
          </tr>
          <tr>
            <td>Vendita libro tramite Stripe</td>
            <td>Esecuzione contratto (lett. b) + obblighi fiscali (lett. c)</td>
            <td>10 anni (obblighi civili/fiscali)</td>
          </tr>
          <tr>
            <td>Analisi statistiche aggregate</td>
            <td>Consenso esplicito (lett. a)</td>
            <td>14 mesi (PostHog default)</td>
          </tr>
          <tr>
            <td>Adempimento obblighi di legge</td>
            <td>Obbligo legale (lett. c)</td>
            <td>Per il tempo previsto dalla legge</td>
          </tr>
        </tbody>
      </table>

      <h2>4. Modalità del trattamento</h2>
      <p>
        Il trattamento è effettuato con strumenti elettronici e con misure
        tecniche e organizzative adeguate, tra cui: cifratura TLS, accesso
        limitato a personale autorizzato, backup periodici, hosting su
        infrastrutture conformi.
      </p>

      <h2>5. Diritti dell'interessato</h2>
      <p>In qualsiasi momento puoi esercitare i seguenti diritti (Artt. 15-22 GDPR):</p>
      <ul>
        <li>diritto di accesso ai propri dati;</li>
        <li>diritto di rettifica dei dati inesatti;</li>
        <li>diritto alla cancellazione ("diritto all'oblio");</li>
        <li>diritto di limitazione del trattamento;</li>
        <li>diritto alla portabilità dei dati;</li>
        <li>diritto di opposizione al trattamento;</li>
        <li>diritto di revocare il consenso in qualsiasi momento (senza pregiudicare la liceità del trattamento precedente);</li>
        <li>
          diritto di proporre reclamo al Garante per la Protezione dei Dati
          Personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a>).
        </li>
      </ul>
      <p>
        Per esercitare i tuoi diritti scrivi a{" "}
        <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a> indicando in oggetto
        "Esercizio diritti GDPR".
      </p>

      <h2>6. Categorie di destinatari</h2>
      <p>
        I dati possono essere comunicati a soggetti terzi che operano in qualità
        di Responsabili del trattamento (Art. 28 GDPR), tra cui:
      </p>
      <ul>
        <li>Fornitori di hosting e infrastruttura cloud;</li>
        <li>Stripe Payments Europe Limited (gestione pagamenti);</li>
        <li>Google LLC (Google Calendar per prenotazione consulenze);</li>
        <li>Amazon EU S.à.r.l. (in caso di acquisto tramite link affiliato);</li>
        <li>PostHog Inc. (statistiche, solo previo consenso);</li>
        <li>Consulenti professionali (commercialista, legale, ove necessario).</li>
      </ul>

      <h2>7. Trasferimento extra-UE</h2>
      <p>
        Alcuni fornitori (Stripe, Google, PostHog) possono trattare dati al di
        fuori dello Spazio Economico Europeo (in particolare negli Stati
        Uniti). Tali trasferimenti avvengono sulla base di:
      </p>
      <ul>
        <li>
          decisioni di adeguatezza della Commissione Europea (es. EU-US Data
          Privacy Framework);
        </li>
        <li>
          Clausole Contrattuali Standard (SCC) approvate dalla Commissione
          Europea;
        </li>
        <li>misure supplementari per garantire un livello di tutela equivalente.</li>
      </ul>

      <h2>8. Conservazione dei dati</h2>
      <p>
        I dati sono conservati per il tempo strettamente necessario al
        perseguimento delle finalità sopra indicate. Al termine, sono cancellati
        o anonimizzati in modo irreversibile, salvo obblighi di legge.
      </p>

      <h2>9. Cookie</h2>
      <p>
        Per informazioni complete sui cookie utilizzati da questo sito consulta
        la{" "}
        <a href="/cookie">Cookie Policy</a>.
      </p>

      <h2>10. Minori</h2>
      <p>
        Questo sito non è rivolto a minori di anni 16. Non raccogliamo
        consapevolmente dati personali di minori. Se ritieni che un minore ci
        abbia fornito dati, contattaci immediatamente.
      </p>

      <h2>11. Modifiche all'informativa</h2>
      <p>
        Il Titolare si riserva il diritto di apportare modifiche alla presente
        Privacy Policy in qualsiasi momento, dandone informazione agli utenti
        tramite pubblicazione su questa pagina. Si prega pertanto di consultare
        regolarmente questa informativa.
      </p>

      <p className="mt-12 text-sm text-[#3A4F6B]">
        Ultimo aggiornamento: {LEGAL.lastUpdated}.
      </p>
    </LegalLayout>
  );
}
